import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FinancialToolComponent } from './financial-tool.component';
import { RouterModule } from '@angular/router';
import { MatTabsModule } from '@angular/material/tabs';
import { DialogFinancialToolsModule } from '@shared/mat-dialogs/financial-tool/financial-tool.module';

@NgModule({
  declarations: [FinancialToolComponent],
  imports: [
    CommonModule,
    RouterModule.forChild([
      { path: '', pathMatch: 'full', redirectTo: 'school' },
      { path: ':type', component: FinancialToolComponent },
      { path: ':type/:tab', component: FinancialToolComponent },
    ]),
    MatTabsModule,
    DialogFinancialToolsModule,
  ],
})
export class FinancialToolModule {}
